import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, TimeoutError, catchError, map, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProjectsAndSalesPlanData } from '../model/project.salesplan.data';
import { RefTypeEnum } from '../../project-intake/enums/ref-type-enum';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { fileBaseVM } from '../../project-intake/models/project-vm';

@Injectable({
  providedIn: 'root'
})
export class ManageService<TBLOB extends Blob> {

  constructor(private httpClient: HttpClient, private toastrService: ToastrService, private ngxService: NgxUiLoaderService
  ) { }

  GetManageProjectsData(manageDto: object): Observable<any> {
    const url = `${environment.gateway_url}/getmanageprojectsdata`;
    return this.httpClient.post<ProjectsAndSalesPlanData>(url, manageDto).pipe(
      map(item => {
        return item;
      })
    );
  }

  DownloadRefStoreList(refId: number, type: string): Observable<any> {
    const url = `${environment.gateway_url}/downloadrefstorelist/${refId}/${type}`
    return this.httpClient.get(url, {
      responseType: 'blob', // Important: responseType must be blob to handle binary data
      observe: 'response'   // Required to access the full HttpResponse, including headers
    }).pipe(
      map((res: HttpResponse<Blob>) => {

        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

  DownloadManageProjectSalesplanList(manageDto: any): Observable<any> {
    let url: string = '';
    if (manageDto.type == RefTypeEnum.Project) {
      url = `${environment.gateway_url}/exportmanageprojectdata`;
    }
    else if (manageDto.type == 'adHoc') {
      url = `${environment.gateway_url}/exportAdHocListdata`;
    }
    else {
      url = `${environment.gateway_url}/exportmanagesalesplandata`;
    }
    return this.httpClient.post(url, manageDto, {
      responseType: 'blob', // Important: responseType must be blob to handle binary data
      observe: 'response'   // Required to access the full HttpResponse, including headers
    }).pipe(
      map((res: HttpResponse<Blob>) => {
        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }


  downloadStoresExcel(event: Event, refId: number, type: RefTypeEnum, projectTitle: string): void {
    event.preventDefault(); // Prevent the default behavior (navigation)
    event.stopPropagation(); // Stop the event from bubbling up
    this.toastrService.info("Download Inprogress..");
    this.ngxService.start();
    this.DownloadRefStoreList(refId, type).subscribe({
      next: (data) => {
        this.ngxService.stop();

        let filename = "StoresList.xlsx";

        if (projectTitle != null
          && projectTitle != undefined
          && projectTitle.length > 0
        ) {
          filename = `Store_${projectTitle}.xlsx`;
        }
        this.downloadFile(data, filename);
        this.toastrService.clear();
        this.toastrService.success("Store list downloaded successfully");
      },
      error: (error) => {
        this.ngxService.stop();
        this.toastrService.clear();
        //this.toastrService.error("Unexpected error occurred");
      }
    });
  }

  ExportManageProjectSalesplanExcel(manageDto: any): void {
    this.toastrService.info("Export Inprogress..");
    this.ngxService.start();
    this.DownloadManageProjectSalesplanList(manageDto).subscribe({
      next: (data) => {
        this.ngxService.stop();
        this.downloadFile(data, manageDto.type + 'List.xlsx');
        this.toastrService.clear();
        this.toastrService.success(manageDto.type + " list exported successfully");
      },
      error: (error) => {
        this.ngxService.stop();
        //this.toastrService.error("Unexpected error occurred");
      }
    });
  }

  ExportManageAdHocListExcel(manageDto: any): void {
    this.toastrService.info("Export Inprogress..");
    this.ngxService.start();
    this.DownloadManageProjectSalesplanList(manageDto).subscribe({
      next: (data) => {
        this.ngxService.stop();
        this.downloadFile(data, 'AdHocList.xlsx');
        this.toastrService.clear();
        this.toastrService.success("Ad Hoc list exported successfully");
      },
      error: (error) => {
        this.ngxService.stop();
        //this.toastrService.error("Unexpected error occurred");
      }
    });
  }


  downloadFile(blob: TBLOB, filename: string): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }

  downloadZipFile(blob: Blob, filename: string): void {
    if (blob) {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);

      a.href = objectUrl;
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(objectUrl);
    } else {
      alert('Download link or blob is not set.');
    }
  }


  getInstructionsToDownload(refId: number, refType: string) {
    const url = `${environment.gateway_url}/downloadinstructions/${refId}/${refType}`;
    return this.httpClient.get(url, { responseType: 'blob' });
  }
  base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteLength = byteCharacters.length;
    const byteArray = new Uint8Array(byteLength);

    for (let i = 0; i < byteLength; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([byteArray], { type: contentType });
  }

  downloadSpecificFile(blobContent: Blob, fileName: string, fileExtension: string): void {
    let mimeType: string;

    switch (fileExtension) {
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      case 'eml':
        mimeType = 'message/rfc822';
        break;
      case 'xlsx':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'csv':
        mimeType = 'text/csv';
        break;
      default:
        mimeType = 'application/octet-stream';
    }

    const blob = new Blob([blobContent], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.${fileExtension}`;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  ExtractManageSalesplanExcel(manageDto: any): void {
    this.toastrService.info("Export in progress...");
    this.ngxService.start();

    this.DownloadManageSalesplanList(manageDto).subscribe({
      next: (blob: Blob) => {
        this.ngxService.stop();

        this.downloadZipFile(blob, "SalesPlanReport.zip");

        this.toastrService.clear();
        this.toastrService.success("Sales Plan report exported successfully.");
      },
      error: () => {
        this.ngxService.stop();
        this.toastrService.clear();
        this.toastrService.error("Failed to export Sales Plan report.");
      }
    });
  }

  DownloadManageSalesplanList(manageDto: any): Observable<Blob> {
    const url = `${environment.gateway_url}/extractsalesplansdata`;

    return this.httpClient.post(url, manageDto, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      timeout(300000),
      map((res: HttpResponse<Blob>) => res.body!), // return directly, no wrapping
      catchError((err) => {
        if (err instanceof TimeoutError) {
          console.error('Export timed out after 5 minutes');
        }
        throw err;
      })
    );
  }
}
